<template>
    <div>
        <app-sub-title text="Recomendaciones de seguridad"/>
        <app-safety-recommendations-filters
            @filter="onFilter"
        />
        <app-safety-recommendations-list
            :data="data"
            @change-page="changePage"
            @sort="onSort"
        />       
    </div>  
</template>

<script>
import SafetyRecommendationsList from './SafetyRecommendationsList/SafetyRecommendationsList';
import SafetyRecommendationsFilters from './SafetyRecommendationsFilters/SafetyRecommendationsFilters';
import safetyRecommendationsRepository from '../../../repositories/safetyRecommendations.repository';
export default {
    components: {
        appSafetyRecommendationsList: SafetyRecommendationsList,
        appSafetyRecommendationsFilters: SafetyRecommendationsFilters
    },
    props: {
        isSupervision: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            data: {},
            selectRecommendation: '',
            sort: {
                sortBy: 'created_at',
                sortDir: 'desc'
            },
            theFilters: {},
            page: 1,
            files: ''
        }
    },

    methods: {
        loadSafetyRecommendations(){
            const srr = {...safetyRecommendationsRepository};
            const filters = {...this.theFilters , sortBy: this.sort.sortBy, sortDir: this.sort.sortDir };
            srr.loadSafetyRecommendations(filters, this.page)
                .then(data => {
                    this.data = data;
                })
                .catch(error => {
                    toastr.error('Error al cargar las recomendaciones de seguridad');
                });
        },
        changePage(page){
            this.page = page;
            this.loadSafetyRecommendations();
        },
        onFilter(filters){
            this.theFilters = filters;
            this.loadSafetyRecommendations();
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadSafetyRecommendations();
        },
        initialize(){
            this.loadSafetyRecommendations();
        }
    },
    created(){
        this.initialize();
    }

}
</script>
